import { useState, useEffect } from 'react';
import type { InsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import { AttributeTypeMap } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute-types.tsx';
import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';
import type { UserInlineEditValue } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/picker-options.tsx';

export const getUserValues = (attribute?: InsightObjectAttribute): UserInlineEditValue[] => {
	if (attribute && attribute.type === 'user') {
		return attribute.userTypeValues.map(({ user }) => ({
			avatarUrl: user.avatarUrl,
			displayName: user.displayName,
			accountId: user.key,
		}));
	}
	return [];
};

export const getUserValuesFromCmdbObjectAttribute = (
	attribute?: CmdbObjectAttribute,
): UserInlineEditValue[] => {
	if (attribute && attribute.type === AttributeTypeMap.User) {
		return attribute.objectAttributeValues
			.filter(({ user }) => user.key)
			.map(({ user }) => ({
				avatarUrl: user.avatarUrl ?? '',
				displayName: user.displayName ?? '',
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				accountId: user.key!,
			}));
	}
	return [];
};

export const useUserValue = (attribute?: InsightObjectAttribute) => {
	const users = getUserValues(attribute);
	const [value, setValue] = useState<UserInlineEditValue[]>(users);

	useEffect(() => {
		setValue(() => getUserValues(attribute));
	}, [attribute]);

	return [value, setValue] as const;
};
